import _objectSpread from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { ERROR_CHECKING } from "./context";

var Mesh =
/*#__PURE__*/
function () {
  function Mesh(context) {
    _classCallCheck(this, Mesh);

    this.context = context;
    this.buffers = {};
    this.sizes = {};
    this.types = {};
  }

  _createClass(Mesh, [{
    key: "destroy",
    value: function destroy() {
      for (var _i = 0, _Object$keys = Object.keys(this.buffers); _i < _Object$keys.length; _i++) {
        var name = _Object$keys[_i];
        this.context.gl.deleteBuffer(this.buffers[name]);
      }

      this.buffers = {};
      delete this.vertexCount;
    }
  }, {
    key: "setPositions",
    value: function setPositions(vertexTriplets) {
      return this.setCustom(vertexTriplets, "positions", 3, this.context.gl.FLOAT);
    }
  }, {
    key: "setNormals",
    value: function setNormals(normalTriplets) {
      return this.setCustom(normalTriplets, "normals", 3, this.context.gl.FLOAT);
    }
  }, {
    key: "setTriangleIndices",
    value: function setTriangleIndices(indexTriplets) {
      var GL = this.context.gl;
      var data = indexTriplets;

      if (Array.isArray(indexTriplets)) {
        data = new Uint16Array(indexTriplets.flat());
      }

      if (this.buffers.triangleIndices) {
        GL.deleteBuffer(this.buffers.triangleIndices);
      }

      this.buffers.triangleIndices = this.context.newBuffer(function () {
        GL.bufferData(GL.ELEMENT_ARRAY_BUFFER, data, GL.STATIC_DRAW);
      }, GL.ELEMENT_ARRAY_BUFFER);
      this.indexCount = data.length;
      return this;
    }
  }, {
    key: "setColorUVCoords",
    value: function setColorUVCoords(uvPairs) {
      return this.setCustom(uvPairs, "colorUV", 2, this.context.gl.FLOAT);
    }
  }, {
    key: "setNormalUVCoords",
    value: function setNormalUVCoords(uvPairs) {
      return this.setCustom(uvPairs, "normalUV", 2, this.context.gl.FLOAT);
    }
  }, {
    key: "setSpecularUVCoords",
    value: function setSpecularUVCoords(uvPairs) {
      return this.setCustom(uvPairs, "specularUV", 2, this.context.gl.FLOAT);
    }
  }, {
    key: "setCustom",
    value: function setCustom(data, name, size, glDataType) {
      this.internalMakeBuffer(data, name, size);
      this.types[name] = glDataType;
      this.sizes[name] = size;
      return this;
    }
  }, {
    key: "makeDrawVao",
    value: function makeDrawVao(attributeMappings) {
      var _this = this;

      var GL = this.context.gl;
      var hasIndices = !!this.buffers.triangleIndices;
      var count = hasIndices ? this.indexCount : this.vertexCount;
      var vao = this.context.newVertexArray(function (vao) {
        for (var _i2 = 0, _Object$keys2 = Object.keys(attributeMappings); _i2 < _Object$keys2.length; _i2++) {
          var bufferName = _Object$keys2[_i2];
          var attribute = attributeMappings[bufferName];

          _this.context.bindArrayBuffer(attribute, _this.buffers[bufferName], _this.sizes[bufferName], {
            type: _this.types[bufferName]
          });
        }

        if (hasIndices) {
          GL.bindBuffer(GL.ELEMENT_ARRAY_BUFFER, _this.buffers.triangleIndices);
        }
      });
      return {
        vao: vao,
        draw: function draw() {
          GL.bindVertexArray(vao);

          if (hasIndices) {
            GL.drawElements(GL.TRIANGLES, count, GL.UNSIGNED_SHORT, 0);
          } else {
            GL.drawArrays(GL.TRIANGLES, 0, count);
          }

          if (_this.context.errorChecking >= ERROR_CHECKING.ALL && GL.getError() !== GL.NO_ERROR) {
            throw new Error("GL error while drawing mesh");
          }
        },
        destroy: function destroy() {
          GL.deleteVertexArray(vao);
        }
      };
    }
  }, {
    key: "merge",
    value: function merge(otherMesh) {
      var _this2 = this;

      var myBufferNames = Object.keys(this.buffers);
      var otherBufferNames = Object.keys(otherMesh.buffers);
      var commonNames = myBufferNames.filter(function (name) {
        return otherBufferNames.includes(name);
      });
      var onlyInMe = myBufferNames.filter(function (name) {
        return !otherBufferNames.includes(name);
      });
      var onlyInOther = otherBufferNames.filter(function (name) {
        return !myBufferNames.includes(name);
      });

      if (myBufferNames.includes("triangleIndices") !== otherBufferNames.includes("triangleIndices")) {
        throw new Error("Cannot merge indexed mesh with non-indexed mesh");
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var name = _step.value;

          if (_this2.sizes[name] !== otherMesh.sizes[name]) {
            throw new Error("Cannot merge meshes: buffer ".concat(name, " differed in data type size (").concat(_this2.sizes[name], " vs ").concat(otherMesh.sizes[name], ")"));
          }

          if (_this2.types[name] !== otherMesh.types[name]) {
            throw new Error("Cannot merge meshes: buffer ".concat(name, " differed in data type (").concat(Object.keys(_this2.context.gl).filter(function (t) {
              return _this2.context.gl[t] === _this2.types[name];
            }), " vs ").concat(Object.keys(_this2.context.gl).filter(function (t) {
              return _this2.context.gl[t] === otherMesh.types[name];
            }), ")"));
          }
        };

        for (var _iterator = commonNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (commonNames.length > 0 && (onlyInMe.length > 0 || onlyInOther.length > 0)) {
        throw new Error("Cannot merge meshes: can only merge meshes with the exact same buffer names or completely disjoint buffer names. Common: ".concat(commonNames.join(", "), "; Only in me: ").concat(onlyInMe.join(", "), "; Only in other: ").concat(onlyInOther.join(", ")));
      } else if (onlyInMe.length > 0 && onlyInOther.length > 0) {
        if (this.vertexCount !== otherMesh.vertexCount) {
          throw new Error("Cannot merge meshes: meshes with disjoint buffer names can only be merged if they describe the same number of vertices (".concat(this.vertexCount, " vs ").concat(otherMesh.vertexCount, ")"));
        }
      }

      var newMesh = new Mesh(this.context);

      if (commonNames.length > 0) {
        this.internalCommonMerge(newMesh, otherMesh);
      } else {
        this.internalDisjointMerge(newMesh, otherMesh);
      }

      return newMesh;
    }
  }, {
    key: "internalMakeBuffer",
    value: function internalMakeBuffer(unknownData, name, size) {
      var GL = this.context.gl;
      var data = unknownData;

      if (Array.isArray(unknownData)) {
        data = new Float32Array(unknownData.flat());
      }

      if (data.length % size !== 0) {
        throw new Error("Input length was not a multiple of ".concat(size, ". Length: ").concat(data.length));
      }

      if (this.vertexCount && this.vertexCount * size !== data.length) {
        throw new Error("Cannot redefined mesh vertex count. Was ".concat(this.vertexCount, " but tried to set ").concat(data.length / size));
      }

      if (this.buffers[name]) {
        GL.deleteBuffer(this.buffers[name]);
      }

      this.buffers[name] = this.context.newBuffer(function () {
        GL.bufferData(GL.ARRAY_BUFFER, data, GL.STATIC_DRAW);
      });
      this.vertexCount = data.length / size;

      if (this.context.errorChecking >= ERROR_CHECKING.SOME && GL.getError() !== GL.NO_ERROR) {
        throw new Error("GL error while buffering data for buffer " + name);
      }
    }
  }, {
    key: "internalCommonMerge",
    value: function internalCommonMerge(newMesh, otherMesh) {
      var _this3 = this;

      var GL = this.context.gl;
      var buffersExcludingIndices = Object.keys(this.buffers).filter(function (name) {
        return name !== "triangleIndices";
      });
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop2 = function _loop2() {
          var bufferName = _step2.value;
          newMesh.buffers[bufferName] = _this3.context.newBuffer(function () {
            var myDataSize = _this3.vertexCount * _this3.sizes[bufferName] * Float32Array.BYTES_PER_ELEMENT;
            var otherDataSize = otherMesh.vertexCount * otherMesh.sizes[bufferName] * Float32Array.BYTES_PER_ELEMENT;
            GL.bufferData(GL.COPY_WRITE_BUFFER, myDataSize + otherDataSize, GL.STATIC_DRAW);
            GL.bindBuffer(GL.COPY_READ_BUFFER, _this3.buffers[bufferName]);
            GL.copyBufferSubData(GL.COPY_READ_BUFFER, GL.COPY_WRITE_BUFFER, 0, 0, myDataSize);
            GL.bindBuffer(GL.COPY_READ_BUFFER, otherMesh.buffers[bufferName]);
            GL.copyBufferSubData(GL.COPY_READ_BUFFER, GL.COPY_WRITE_BUFFER, 0, myDataSize, otherDataSize);
          }, GL.COPY_WRITE_BUFFER);
          newMesh.sizes[bufferName] = _this3.sizes[bufferName];
          newMesh.types[bufferName] = _this3.types[bufferName];
        };

        for (var _iterator2 = buffersExcludingIndices[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          _loop2();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (this.buffers.triangleIndices) {
        newMesh.buffers.triangleIndices = this.context.newBuffer(function (newBuffer) {
          var myDataSize = _this3.indexCount * Uint16Array.BYTES_PER_ELEMENT;
          var otherDataSize = otherMesh.indexCount * Uint16Array.BYTES_PER_ELEMENT;
          GL.bufferData(GL.ELEMENT_ARRAY_BUFFER, myDataSize + otherDataSize, GL.STATIC_DRAW);
          var myArrayBuffer = new Uint16Array(_this3.indexCount);
          GL.bindBuffer(GL.ELEMENT_ARRAY_BUFFER, _this3.buffers.triangleIndices);
          GL.getBufferSubData(GL.ELEMENT_ARRAY_BUFFER, 0, myArrayBuffer);
          GL.bindBuffer(GL.ELEMENT_ARRAY_BUFFER, newBuffer);
          GL.bufferSubData(GL.ELEMENT_ARRAY_BUFFER, 0, myArrayBuffer);
          var otherArrayBuffer = new Uint16Array(otherMesh.indexCount);
          GL.bindBuffer(GL.ELEMENT_ARRAY_BUFFER, otherMesh.buffers.triangleIndices);
          GL.getBufferSubData(GL.ELEMENT_ARRAY_BUFFER, 0, otherArrayBuffer);

          for (var i = 0; i < otherMesh.indexCount; i++) {
            otherArrayBuffer[i] += _this3.vertexCount;
          }

          GL.bindBuffer(GL.ELEMENT_ARRAY_BUFFER, newBuffer);
          GL.bufferSubData(GL.ELEMENT_ARRAY_BUFFER, myDataSize, otherArrayBuffer);
        }, GL.ELEMENT_ARRAY_BUFFER);
        newMesh.indexCount = this.indexCount + otherMesh.indexCount;
      }

      newMesh.vertexCount = this.vertexCount + otherMesh.vertexCount;
    }
  }, {
    key: "internalDisjointMerge",
    value: function internalDisjointMerge(newMesh, otherMesh) {
      newMesh.vertexCount = this.vertexCount;
      newMesh.buffers = _objectSpread({}, this.buffers, otherMesh.buffers);
      newMesh.sizes = _objectSpread({}, this.sizes, otherMesh.sizes);
      newMesh.types = _objectSpread({}, this.types, otherMesh.types);
    }
  }]);

  return Mesh;
}();

export { Mesh as default };